/* eslint-disable import/prefer-default-export */

import { COPY_PX } from 'src/store/ActionTypes';

export const setCopyPx = (pxScores) => ({
  type: COPY_PX.SET_COPY_PX,
  payload: pxScores,
});

export const fetchSegments = (query) => ({
  type: COPY_PX.FETCH_SEGMENTS,
  payload: query,
});

export const fetchHighValueWords = (segmentId, clusterId, wvmId) => ({
  type: COPY_PX.FETCH_HIGH_VALUE_WORDS,
  payload: {
    segmentId,
    clusterId,
    wvmId,
  },
});

export const selectGridRow = (row) => ({
  type: COPY_PX.SELECT_GRID_ROW,
  payload: row,
});

export const deselectGridRow = (row) => ({
  type: COPY_PX.DESELECT_GRID_ROW,
  payload: row,
});

export const setGridState = (state) => ({
  type: COPY_PX.SET_GRID_STATE,
  payload: state,
});

export const deselectAllGridRows = () => ({
  type: COPY_PX.DESELECT_ALL_GRID_ROWS,
});

export const editSegment = (id, payload) => ({
  type: COPY_PX.EDIT_SEGMENT,
  payload: {
    id,
    payload,
  },
});
